import { combineReducers } from 'redux'

import attachedDocumentsReducer from '../api/features/attachedDocuments'
import placeOfExpenceReducer from '../api/features/placeOfExpence'
import { api } from './api'
import companyReducer from './features/companySlice'
import fileReducer from './features/fileSlice'
import { switchCompany } from './features/sessionActions'
import sidebarReducer from './features/sidebarSlice'
import stampReducer from './features/stampSlice'
import userReducer, { logout } from './features/userSlice'

const appReducer = combineReducers({
  file: fileReducer,
  stamp: stampReducer,
  placeOfExpence: placeOfExpenceReducer,
  attachedDocuments: attachedDocumentsReducer,
  company: companyReducer,
  user: userReducer,
  sidebar: sidebarReducer,
  [api.reducerPath]: api.reducer,
})

// Work-in-progress state tied to the active company. The company slice handles these
// actions itself and the RTK Query cache is reset by a listener in store.js.
const COMPANY_SCOPED_SLICES = ['file', 'stamp', 'placeOfExpence', 'attachedDocuments']

export const rootReducer = (state, action) => {
  if (state && (logout.match(action) || switchCompany.match(action))) {
    state = { ...state }
    COMPANY_SCOPED_SLICES.forEach((key) => {
      state[key] = undefined
    })
  }
  return appReducer(state, action)
}
